import type { ReferrerStatus } from "@redotech/admin-sdk/rpc/schema/referrers/shared";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { memo } from "react";

import { REFERRER_STATUS_BADGE_PROPS } from "../lib/referrer-status-badge-props";

interface ReferrerStatusBadgeProps {
  status: ReferrerStatus;
  className?: string;
}

export const ReferrerStatusBadge = memo(function ReferrerStatusBadge({
  status,
  className,
}: ReferrerStatusBadgeProps) {
  const props = REFERRER_STATUS_BADGE_PROPS[status];
  return (
    <RedoBadge className={className} color={props.color} text={props.text} />
  );
});
